import dayjs from 'dayjs';
import type { CreateWorkTask, WorkTaskTypeCatalogItem } from 'api-client';
import { ASSIGNEE_ALL_VALUE } from './assigneeOptions';
import type { CreateWorkContext, CreateWorkFormValues } from './types';

interface BuildPayloadArgs {
  context: CreateWorkContext;
  values: CreateWorkFormValues;
  taskType: WorkTaskTypeCatalogItem;
}

export function buildCreateWorkTaskPayload({
  context,
  values,
  taskType,
}: BuildPayloadArgs): CreateWorkTask {
  return {
    assetId: context.assetId,
    tp2AssetId: context.tp2AssetId,
    taskType: {
      taskTypeLabel: taskType.taskTypeLabel,
      taskTypeCategoryLabel: taskType.taskTypeCategoryLabel,
    },
    priority: values.priority,
    dueDate: values.dueDate ? dayjs(values.dueDate).valueOf() : null,
    // "All" is the visual-only fallback shown when the tenant has no assignees; it
    // (like an empty selection) maps to no assignee, mirroring the TPM Work Filter.
    tp2AssignedTo:
      values.assignedTo && values.assignedTo !== ASSIGNEE_ALL_VALUE ? values.assignedTo : null,
  };
}
